import {Scheme} from '../../scheme/domain/scheme.model';

export enum FacetKey {
  PRODUCTS = 'products',
  PRODUCTS_CASCADE = 'productsCascade',
  CONTROL_PLATFORMS = 'controlPlatforms',
}

export enum FacetNodeType {
  EXTENDED,
  SIMPLE
}

export interface ExtendedFacetNode {
  type: FacetNodeType.EXTENDED;
  id: string;
  label: string;
  count: number;
  level: string;
  filterField: string;
  filterValue: string;
  children?: ExtendedFacetNode[];
}

export interface SimpleFacetNode {
  type: FacetNodeType.SIMPLE;
  value: string;
  count: number;
}

export type FacetNode =
  | ExtendedFacetNode
  | SimpleFacetNode;

export type Facets = {
  [FacetKey.PRODUCTS]: ExtendedFacetNode[];
  [FacetKey.PRODUCTS_CASCADE]: ExtendedFacetNode[];
  [FacetKey.CONTROL_PLATFORMS]: SimpleFacetNode[];
};

export interface SearchPage {
  hasMore: boolean;
  nextCursor: string | null;
}

export interface Search {
  items: Scheme[];
  total: number;
  facets: Facets | null;
  page: SearchPage;
}

export interface SearchRequest {
  country: string;
  language: string;
  filters: Facets | null;
  query: string | null;
  cursor: string | null;
}
